import useResizeObserver from './useResizeObserver';

export default useResizeObserver;